import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";

const RULES = [
  { label: "Mínimo 8 caracteres",   test: (p) => p.length >= 8 },
  { label: "Al menos una mayúscula", test: (p) => /[A-Z]/.test(p) },
  { label: "Al menos una minúscula", test: (p) => /[a-z]/.test(p) },
  { label: "Al menos un número",     test: (p) => /[0-9]/.test(p) },
];

export function passwordIsStrong(pwd) {
  return RULES.every((r) => r.test(pwd));
}

export default function PasswordStrength({ password }) {
  if (!password) return null;
  return (
    <div className="mt-2 space-y-1">
      {RULES.map(({ label, test }) => {
        const ok = test(password);
        return (
          <div key={label} className="flex items-center gap-1.5">
            {ok
              ? <CheckCircle2 size={12} className="text-emerald-500 dark:text-emerald-400 shrink-0" />
              : <XCircle      size={12} className="text-slate-300 dark:text-slate-600 shrink-0" />
            }
            <span className={`text-[11px] font-medium transition-colors duration-150 ${
              ok ? "text-emerald-600 dark:text-emerald-400" : "text-slate-400 dark:text-slate-500"
            }`}>
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
